export default "__VITE_ASSET__e2948636__"